module.exports = __webpack_public_path__ + "img/nav05_h.af1e25ce.png";